import { useEffect, useState } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Profile } from "@/models/database/profiles/profile.model";
import { JunctionProfileChallenge } from "@/models/database/challenges/junctionProfileChallenge.model";

export const useTenantsJunctionCount = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [count, setCount] = useState<Number>();

  const fetchJunctions = async () => {
    try {
      setLoading(true);
      const profiles: JunctionProfileChallenge[] = [];

      const ref = collectionRef.junctionProfileChallenge
        .where("userChallengeData.points", "!=", 0)
        .where("challengeId", "==", "tcl-time-trial-gamebox");
      const query = await ref.get();

      query.docs.map(async (doc) => {
        profiles.push(doc.data());
      });

      const numberOfProfiles = profiles.length;
      setCount(numberOfProfiles);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!count) {
      fetchJunctions();
    }
  }, [brand.tenantId]);

  return {
    data: count,
    loading,
    error,
  };
};
